/**
 * Leadership Skill Area
 * Lessons focused on strategic decision-making and stakeholder management
 */

export { grantNegotiation } from './grant-negotiation';
export { signalScan } from './signal-scan';
export { momentumBrief } from './momentum-brief';

import { grantNegotiation } from './grant-negotiation';
import { signalScan } from './signal-scan';
import { momentumBrief } from './momentum-brief';
import type { LessonDefinition } from '../types';

export const leadershipLessons: LessonDefinition[] = [
  grantNegotiation,
  signalScan,
  momentumBrief,
];
